import { Action } from '@ngrx/store';
import { ReportLayout } from '../../../vas/business-objects/report-layout/report-layout.model';
import { Report } from '../../../vas/business-objects/report/report.model';

export const DOWNLOAD = '[Job Print] Download';
export const DOWNLOAD_DESKTOP = '[Job Print] Download Desktop';
export const DOWNLOAD_MOBILE = '[Job Print] Download Mobile';
export const INIT = '[Job Print] Initialise';
export const REFRESH_REPORTS = '[Job Print] Refresh Reports';
export const REMOVE_REPORT = '[Job Print] Remove Report'
export const REQUEST_REPORT = '[Job Print] Request Report';
export const SHARE_REPORT = '[Job Print] Share Report';
export const SET_REPORT_LAYOUTS = '[Job Print] Set Report Layouts';
export const SET_REPORTS = '[Job Print] Set Reports';

export class DownloadAction implements Action {
    readonly type = DOWNLOAD;

    constructor(public payload: {
        accountId: string,
        reportId: string,
        filename: string
    }) {
    }
}

export class DownloadDesktopAction implements Action {
    readonly type = DOWNLOAD_DESKTOP;

    constructor(public payload: {
        accountId: string,
        reportId: string,
        filename: string
    }) {
    }
}

export class DownloadMobileAction implements Action {
    readonly type = DOWNLOAD_MOBILE;

    constructor(public payload: {
        accountId: string,
        reportId: string,
        filename: string
    }) {
    }
}

export class InitAction implements Action {
    readonly type = INIT;

    constructor(public payload: {
        accountId: string,
        jobId: string,
        jobType: string
    }) {
    }
}

export class RefreshReportsAction implements Action {
    readonly type = REFRESH_REPORTS;

    constructor(public payload: {
        accountId: string,
        jobId: string
    }) {
    }
}

export class RemoveReportAction implements Action {
    readonly type = REMOVE_REPORT;

    constructor(public payload: Report) {
    }
}

export class RequestReportAction implements Action {
    readonly type = REQUEST_REPORT;

    constructor(public payload: {
        accountId: string,
        jobId: string,
        reportLayoutId: string
    }) {
    }
}

export class ShareReportAction implements Action {
    readonly type = SHARE_REPORT;

    constructor(public payload: {
        accountId: string,
        reportId: string,
        title: string
    }) {

    }
}

export class SetReportLayoutsAction implements Action {
    readonly type = SET_REPORT_LAYOUTS;

    constructor(public payload: {
        reportLayouts: Array<ReportLayout>
    }) {
    }
}

export class SetReportsAction implements Action {
    readonly type = SET_REPORTS;

    constructor(public payload: {
        reports: Array<Report>
    }) {
    }
}

export declare type Actions
    = DownloadAction
    | DownloadDesktopAction
    | DownloadMobileAction
    | InitAction
    | RefreshReportsAction
    | RemoveReportAction
    | RequestReportAction
    | ShareReportAction
    | SetReportLayoutsAction
    | SetReportsAction
    ;



// WEBPACK FOOTER //
// ./src/app/pages/job-print/job-print.actions.ts